"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var flights_1 = require("./flights");
var selection_1 = require("./selection");
// activate the whole selection thing for outgoing or returning flights
function ENABLE(state, which) {
    if (which === 'outgoing') {
        state.outgoingSelection.enabled = true;
    }
    else {
        state.returningSelection.enabled = true;
    }
}
exports.ENABLE = ENABLE;
// deactivate the whole selection thing for outgoing or returning flights
function DISABLE(state, which) {
    if (which === 'outgoing') {
        state.outgoingSelection.enabled = false;
    }
    else {
        state.returningSelection.enabled = false;
    }
}
exports.DISABLE = DISABLE;
// activate the whole selection thing for outgoing or returning flights
function ACTIVATE(state, which) {
    if (which === 'outgoing') {
        state.outgoingSelection.activated = true;
    }
    else {
        state.returningSelection.activated = true;
    }
}
exports.ACTIVATE = ACTIVATE;
// deactivate the whole selection thing for outgoing or returning flights
function DEACTIVATE(state, which) {
    if (which === 'outgoing') {
        state.outgoingSelection.activated = false;
    }
    else {
        state.returningSelection.activated = false;
    }
}
exports.DEACTIVATE = DEACTIVATE;
// import data from an API response
function IMPORT(state, data) {
    // console.log('IMPORT data', JSON.stringify(data))
    state.flights = new flights_1.Flights(data, state.roundtripsOnly);
    state.mandatoryRoundtrip = state.flights.isMandatoryRoundTrip();
}
exports.IMPORT = IMPORT;
function REIMPORT(state) {
    if (lodash_1.isNil(state.flights.addFlightClass)) {
        state.flights = new flights_1.Flights(state.flights, state.roundtripsOnly);
    }
}
exports.REIMPORT = REIMPORT;
// cache the last request signature to prevent concurrency issues
function SET_LOADING(state, key) {
    state.loading = key;
}
exports.SET_LOADING = SET_LOADING;
// return only roundtrips
function SET_ROUNDTRIPS_ONLY(state, option) {
    state.roundtripsOnly = option;
}
exports.SET_ROUNDTRIPS_ONLY = SET_ROUNDTRIPS_ONLY;
// wether the 'Kein Hinflug/Kein Rückflug' option should be added to airport lists
function SET_WITH_NOFLIGHT(state, option) {
    state.withNoFlight = option;
}
exports.SET_WITH_NOFLIGHT = SET_WITH_NOFLIGHT;
// wether the 'Kein Hinflug' option should be added to airport lists
// overrides withNoFlight
function SET_OUT_WITH_NOFLIGHT(state, option) {
    state.withOutNoFlight = option;
}
exports.SET_OUT_WITH_NOFLIGHT = SET_OUT_WITH_NOFLIGHT;
// wether the 'Kein Rückflug' option should be added to airport lists
// overrides withNoFlight
function SET_RET_WITH_NOFLIGHT(state, option) {
    state.withRetNoFlight = option;
}
exports.SET_RET_WITH_NOFLIGHT = SET_RET_WITH_NOFLIGHT;
// select an outgoing flight from any list
function SELECT_OUTGOING(state, code) {
    state.outgoingSelection.selected = code;
    state.flightsOutTouched = false;
}
exports.SELECT_OUTGOING = SELECT_OUTGOING;
// select a returning flight from any list
function SELECT_RETURNING(state, code) {
    state.returningSelection.selected = code;
    state.flightsRetTouched = false;
}
exports.SELECT_RETURNING = SELECT_RETURNING;
// select a flight class for the outgoing flight
function SELECT_OUTGOING_FLIGHT_CLASS(state, code) {
    state.outgoingSelection.flightClass = code;
}
exports.SELECT_OUTGOING_FLIGHT_CLASS = SELECT_OUTGOING_FLIGHT_CLASS;
// select a flight class for the returning flight
function SELECT_RETURNING_FLIGHT_CLASS(state, code) {
    state.returningSelection.flightClass = code;
}
exports.SELECT_RETURNING_FLIGHT_CLASS = SELECT_RETURNING_FLIGHT_CLASS;
// cache a price differ amount for the currently selected air connection
function SET_PRICE_DIFFER(state, differ) {
    state.priceDiffer = differ;
}
exports.SET_PRICE_DIFFER = SET_PRICE_DIFFER;
// cache a price differ amount for the currently selected air connection
function SET_PRICE_DIFFERENCE(state, difference) {
    state.priceDifference = difference;
}
exports.SET_PRICE_DIFFERENCE = SET_PRICE_DIFFERENCE;
function RESET_STATE(state) {
    state.flights = new flights_1.Flights();
    state.loading = '';
    state.mandatoryRoundtrip = false;
    state.outgoingSelection = new selection_1.Selection();
    state.priceDiffer = 0;
    state.priceDifference = 0;
    state.returningSelection = new selection_1.Selection();
    state.roundtripsOnly = false;
    state.selectedConnection = null;
    state.withNoFlight = true;
    state.withOutNoFlight = true;
    state.withRetNoFlight = true;
    state.rnfDeparture = false;
    state.rnfArrival = false;
    state.rnfCategory = '2';
    state.rnfTotalPrice = 0;
    state.rnfTransportations = [];
}
exports.RESET_STATE = RESET_STATE;
function RESET_RNF_STATE(state) {
    state.rnfDeparture = false;
    state.rnfArrival = false;
    state.rnfCategory = '2';
    state.rnfTotalPrice = 0;
    state.rnfTransportations = [];
}
exports.RESET_RNF_STATE = RESET_RNF_STATE;
function MARK_AS_TOUCHED(state) {
    state.flightsOutTouched = true;
    state.flightsRetTouched = true;
}
exports.MARK_AS_TOUCHED = MARK_AS_TOUCHED;
function SET_RNF_DEPARTURE(state, data) {
    state.rnfDeparture = data;
}
exports.SET_RNF_DEPARTURE = SET_RNF_DEPARTURE;
function SET_RNF_ARRIVAL(state, data) {
    state.rnfArrival = data;
}
exports.SET_RNF_ARRIVAL = SET_RNF_ARRIVAL;
function SET_RNF_CATEGORY(state, data) {
    // validate data
    if (data !== '1')
        data = '2';
    state.rnfCategory = data;
}
exports.SET_RNF_CATEGORY = SET_RNF_CATEGORY;
function SET_TRANSPORTATION(state, data) {
    state.rnfTransportations = data;
    SET_RNF_TOTAL_PRICE(state);
}
exports.SET_TRANSPORTATION = SET_TRANSPORTATION;
function SET_RNF_TOTAL_PRICE(state) {
    var totalPrice = 0;
    for (var _i = 0, _a = state.rnfTransportations; _i < _a.length; _i++) {
        var singleTransportation = _a[_i];
        totalPrice += singleTransportation.referencePrice;
    }
    state.rnfTotalPrice = totalPrice;
}
exports.SET_RNF_TOTAL_PRICE = SET_RNF_TOTAL_PRICE;
// export everything compliant to the vuex specification for getters
exports.default = {
    ENABLE: ENABLE, DISABLE: DISABLE,
    ACTIVATE: ACTIVATE, DEACTIVATE: DEACTIVATE,
    IMPORT: IMPORT, REIMPORT: REIMPORT,
    SET_LOADING: SET_LOADING,
    SELECT_OUTGOING: SELECT_OUTGOING, SELECT_RETURNING: SELECT_RETURNING,
    SELECT_OUTGOING_FLIGHT_CLASS: SELECT_OUTGOING_FLIGHT_CLASS, SELECT_RETURNING_FLIGHT_CLASS: SELECT_RETURNING_FLIGHT_CLASS,
    SET_PRICE_DIFFER: SET_PRICE_DIFFER, SET_PRICE_DIFFERENCE: SET_PRICE_DIFFERENCE,
    SET_WITH_NOFLIGHT: SET_WITH_NOFLIGHT, SET_OUT_WITH_NOFLIGHT: SET_OUT_WITH_NOFLIGHT, SET_RET_WITH_NOFLIGHT: SET_RET_WITH_NOFLIGHT,
    SET_ROUNDTRIPS_ONLY: SET_ROUNDTRIPS_ONLY,
    RESET_STATE: RESET_STATE, MARK_AS_TOUCHED: MARK_AS_TOUCHED,
    SET_RNF_ARRIVAL: SET_RNF_ARRIVAL, SET_RNF_DEPARTURE: SET_RNF_DEPARTURE,
    SET_RNF_CATEGORY: SET_RNF_CATEGORY, SET_RNF_TOTAL_PRICE: SET_RNF_TOTAL_PRICE,
    SET_TRANSPORTATION: SET_TRANSPORTATION, RESET_RNF_STATE: RESET_RNF_STATE
};
//# sourceMappingURL=mutations.js.map